export class NeverError extends Error {
  public readonly type = "NeverError"

  constructor(value: never) {
    super(`NeverError: ${value}`);
  }
}

